export class InvalidCreneauException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidCreneauException';
  }
}
